import { useState, type ReactNode } from 'react';
import { SelfCheckScreen, DAY_KEY, todayKey } from './SelfCheckScreen';

/**
 * Today's phone check, before the route opens (owner, 4 Oct: "mandatory").
 *
 * Once per phone per day the route screen is replaced by the app self-test.
 * It is mandatory to RUN, never to pass: when the check finishes a
 * "Continue to my route" button always appears, whatever failed. A driver can
 * never be locked out of their work by this screen.
 *
 * If the phone's storage cannot even be read, the gate stays out of the way —
 * otherwise it would ask again on every visit.
 */
export function DailyCheckGate({ children }: { children: ReactNode }) {
  const [done, setDone] = useState<boolean>(() => {
    try { return localStorage.getItem(DAY_KEY) === todayKey(); } catch { return true; }
  });
  if (done) return <>{children}</>;
  return <SelfCheckScreen gate onDone={() => setDone(true)} />;
}
